module.exports = __webpack_public_path__ + "static/media/Hardmode_5.cd1839a9.jpg";